import { ExternalLink } from 'lucide-react';
import { Badge } from '../../../atoms/badge';
import { Button } from '../../../atoms/button';
import type { BadgeVariant, CardBlock } from '../chat-content';

export function CardBlockRenderer({ block }: { block: CardBlock }) {
  return (
    <div className="overflow-hidden rounded-lg border border-border bg-card text-sm w-full">
      {/* Header */}
      <div className="flex items-start justify-between gap-2 px-4 py-3 border-b border-border">
        <div className="min-w-0">
          <p className="font-medium text-foreground truncate">{block.title}</p>
          {block.subtitle && (
            <p className="text-xs text-muted-foreground mt-0.5 truncate">{block.subtitle}</p>
          )}
        </div>
        {block.badge && (
          <Badge
            variant={(block.badge.variant ?? 'secondary') as BadgeVariant}
            appearance="soft"
            className="shrink-0 mt-0.5"
          >
            {block.badge.label}
          </Badge>
        )}
      </div>

      {/* Fields */}
      {block.fields && block.fields.length > 0 && (
        <dl className="divide-y divide-border">
          {block.fields.map((f) => (
            <div key={f.label} className="flex items-baseline justify-between gap-4 px-4 py-2">
              <dt className="text-xs text-muted-foreground shrink-0">{f.label}</dt>
              <dd className="text-xs text-foreground text-right truncate">{f.value}</dd>
            </div>
          ))}
        </dl>
      )}

      {/* Actions */}
      {block.actions && block.actions.length > 0 && (
        <div className="flex flex-wrap items-center gap-2 px-4 py-2.5 border-t border-border bg-muted/30">
          {block.actions.map((a) =>
            a.href ? (
              <Button
                key={a.label}
                size="sm"
                variant={a.variant ?? 'secondary'}
                appearance="outline"
                className="h-7 text-xs"
                asChild
              >
                <a
                  href={a.href}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-1"
                >
                  {a.label}
                  <ExternalLink className="size-3" />
                </a>
              </Button>
            ) : (
              <Button
                key={a.label}
                size="sm"
                variant={a.variant ?? 'secondary'}
                appearance="outline"
                className="h-7 text-xs"
              >
                {a.label}
              </Button>
            ),
          )}
        </div>
      )}
    </div>
  );
}
